import type { SlateBlock, SlateLeaf } from '@atlas/renderer';
import type React from 'react';
import { Transforms, Editor } from 'slate';
import isMarkActive from '@atlas/tool/box/slate/isMarkActive';
import matchNode from '@atlas/tool/box/slate/matchNode';
import changeEditorSelection from '@atlas/tool/box/slate/changeEditorSelection';

export default function handleLinkEditingKeyDownEvent(editor: Editor, event: React.KeyboardEvent): boolean {
    if (!editor.selection) return false;

    if (event.key.length !== 1) return false;
    if (event.metaKey || !event.altKey || event.ctrlKey) return false;

    const { anchor, focus } = editor.selection;
    if (anchor.offset !== focus.offset) return false;
    if (anchor.path.length !== focus.path.length) return false;
    if (anchor.path.some((index, i) => focus.path[i] !== index)) return false;

    if (!isMarkActive(editor, 'link')) return false;

    const node = matchNode<SlateLeaf>(editor, (node) => 'link' in node && typeof node.link === 'string');

    if (!node || editor.selection.focus.offset !== node.text.length) return false;

    const path = focus.path.slice(0, -1).concat(focus.path[focus.path.length - 1] + 1);
    const hasChild = !!path.reduce((child: Editor | SlateBlock | SlateLeaf | undefined, index) => {
        if (!child) return;
        if ('children' in child) return child.children[index];
    }, editor);
    if (!hasChild) {
        event.preventDefault();
        Transforms.insertFragment(editor, [{ text: event.key }]);
    } else {
        changeEditorSelection(editor, {
            anchor: { path, offset: 0 },
            focus: { path, offset: 0 },
        });
    }

    return true;
}

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('handleTableNavigationKeyDownEvent', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
